import { Reveal } from "@/components/Reveal";
import { useSeo } from "@/hooks/useSeo";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Accessibility() {
  useSeo({ title: "Accessibility Statement | Inforno Travel", description: "Inforno Travel is committed to making its website accessible and usable for all travelers." });
  return (
    <div className="bg-noir min-h-screen">
      <Navbar />
      <section className="py-28 md:py-36 px-6 md:px-12">
        <div className="max-w-3xl mx-auto">
          <Reveal>
            <p className="font-body text-[11px] uppercase tracking-[0.45em] text-gold mb-6">Accessibility Statement</p>
            <h1 className="font-serif font-light tracking-tighter leading-[0.95] text-4xl sm:text-5xl text-ink">Travel is for everyone. <span className="italic text-gold">So is this website.</span></h1>
            <div className="mt-10 space-y-6 font-body text-white/65 text-base leading-relaxed font-light">
              <p>Inforno Travel is committed to providing a website that is accessible and usable for all visitors, including people with disabilities. We aim to align with the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA.</p>
              <p>Our ongoing efforts include semantic page structure, meaningful alternative text for imagery, keyboard-navigable interfaces, visible focus indicators, form labels, sufficient color contrast, and support for reduced-motion preferences.</p>
              <p>Accessibility is an ongoing effort. If you experience any difficulty using this website, or if any part of it is not working for you, please let us know and we will work with you to provide the information or service you need.</p>
              <p>
                Contact us at <a href="mailto:info@infornotravel.com" className="text-gold link-underline">info@infornotravel.com</a> or{" "}
                <a href="tel:+12028165560" className="text-gold link-underline">(202) 816-5560</a>, Monday–Friday, 8:30 AM – 5:30 PM ET.
              </p>
            </div>
          </Reveal>
        </div>
      </section>
      <Footer />
    </div>
  );
}
